<template>
  <div class="app-container">
    <div style="margin-top: 30px;width: 100%;" />
    <div class="download-container">
      <div class="app-logo">
        <img src="@/assets/logo.jpg" alt="App Logo" style="width: 100%;">
      </div>
      <h1 class="app-name">搜机网APP</h1>
      <p class="app-desc">专业手机查询、比价、评测平台<br>一键获取最新手机资讯</p>

      <!-- WeChat Browser Warning -->
      <div v-if="isWechat" class="wechat-warning">
        <p>请在浏览器中打开此页面以完成下载</p>
        <van-button class="browser-guide-btn" @click="showBrowserGuide">
          查看操作指引
        </van-button>
      </div>

      <!-- Loading indicator -->
      <div v-show="loading && !isWechat" class="loading">正在识别手机型号，即将跳转...</div>

      <!-- Download button (only shown when not in WeChat) -->
      <van-button
        v-if="!isWechat"
        class="download-btn"
        :disabled="loading"
        @click="jumpToDownload">
        {{ loading ? '正在跳转...' : '立即下载' }}
      </van-button>

      <p class="tip-text">
        支持华为、小米、OPPO、vivo等主流手机品牌
      </p>
    </div>
    <div class="footer">
      <p>© 2025 搜机网. 保留所有权利</p>
      <van-button
        type="text"
        size="small"
        class="privacy-policy"
        @click="showPrivacyPolicy">
        隐私政策
      </van-button>
    </div>
    <!-- Browser Guide Popup -->
    <van-popup v-model="showGuide" position="bottom" round>
      <div class="guide-content">
        <h5>在浏览器中打开</h5>
        <p>请点击右上角<span class="action-btn">...</span>， 选择<span class="action-text">在浏览器中打开</span>以下载应用</p>
        <div class="guide-image-placeholder">
          <!-- You can add an image here showing the menu options -->
          <p><img src="@/assets/guide.png" style="width: 100%;"></p>
        </div>
        <van-button type="primary" block @click="showGuide = false">我知道了</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      showGuide: false,
      appLinks: {
        ios: 'https://apps.apple.com/cn/app/id6753326572', // App Store链接（替换id）
        huawei: 'https://appgallery.huawei.com/app/C115283607', // 华为应用市场链接
        xiaomi: 'https://app.mi.com/details?id=com.search.machine.net', // 小米应用商店链接
        // oppo: 'https://store.oppomobile.com/app/detail?id=xxxxxx', // OPPO软件商店链接
        vivo: 'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=4327746',
        // default: 'https://sj.qq.com/appdetail/com.search.machine.net' // 备用链接（应用宝）
        default: 'https://www.souji168.cn/release/sdnet.apk' // 备用链接（应用宝）
      }
    }
  },

  computed: {
    // Detect if user is in WeChat browser
    isWechat () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    }
  },

  methods: {
    // Show browser operation guide
    showBrowserGuide () {
      this.showGuide = true
    },

    // 2. 手机品牌识别逻辑
    getPhoneInfo () {
      const ua = navigator.userAgent.toLowerCase()
      let brand = 'default'

      // 识别主流安卓品牌
      if (ua.includes('huawei') || ua.includes('honor')) brand = 'huawei'
      else if (ua.includes('mi') || ua.includes('xiaomi')) brand = 'xiaomi'
      else if (ua.includes('oppo')) brand = 'oppo'
      else if (ua.includes('vivo') || ua.includes('iqoo')) brand = 'vivo'
      else if (ua.includes('samsung')) brand = 'samsung'

      // 识别系统
      const system = /iphone|ipad|ipod|ios/.test(ua) ? 'ios' : 'android'
      return { system, brand }
    },

    // 3. 跳转下载逻辑
    jumpToDownload () {
      if (this.loading) return

      // Prevent download attempt in WeChat
      if (this.isWechat) {
        this.showBrowserGuide()
        return
      }

      const { system, brand } = this.getPhoneInfo()
      let targetLink = this.appLinks.default

      // 匹配对应链接
      if (system === 'ios') {
        targetLink = this.appLinks.ios
      } else if (this.appLinks[brand]) {
        targetLink = this.appLinks[brand]
      }

      // 执行跳转
      this.loading = true
      setTimeout(() => {
        window.location.href = targetLink

        // If redirect fails, show browser guide instead of manual download prompt
        setTimeout(() => {
          this.loading = false
          this.showBrowserGuide()
        }, 3000)
      }, 500)
    },

    // 显示隐私政策
    showPrivacyPolicy () {
      this.$dialog.alert({
        title: '隐私政策',
        message: '我们重视您的隐私，不会收集您的个人信息。详细隐私政策请访问我们的官方网站。'
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  box-sizing: border-box;
  font-family: 'PingFang SC', 'Helvetica Neue', sans-serif;
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}
.action-btn {
  color: #3B82F6;
  font-weight: bold;
}
.download-container {
  width: 80%;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.app-logo {
  overflow: hidden;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  border-radius: 16px;
  background: #2f54eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}

.app-name {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.app-desc {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.5;
}

.wechat-warning {
  background-color: #f0f7ff;
  border: 1px solid #bae0ff;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.wechat-warning p {
  color: #3B82F6;
  margin-bottom: 10px;
}

.browser-guide-btn {
  width: 100%;
  background: #1d39c4;
  border: 1px solid #1d39c4;
  color: #ffffff;
  border-radius: 25px;
}

.download-btn {
  display: block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #2f54eb;
  color: #fff;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 15px;
  transition: background 0.3s;
  border: none;
}

.download-btn:hover {
  background: #1d39c4;
}

.download-btn:disabled {
  background: #1d39c4;
}

.tip-text {
  font-size: 12px;
  color: #999;
  text-align: center;
  line-height: 1.6;
}

.loading {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.footer {
  text-align: center;
  padding: 20px 16px;
  color: #999;
  font-size: 12px;
  border-top: 1px solid #eee;
}

.privacy-policy {
  color: #3B82F6 !important;
  padding: 0 !important;
  margin-top: 8px;
  border: 0;
  background-color: #f5f7fa;
}

.guide-content {
  padding: 20px;
}

.guide-content h3 {
  text-align: center;
  margin-bottom: 15px;
}

.guide-content ul {
  padding-left: 20px;
  margin: 10px 0;
}

.guide-content li {
  margin-bottom: 5px;
}

.guide-image-placeholder {
  background-color: #f5f5f5;
  border-radius: 4px;
  text-align: center;
  margin: 15px 0;
  color: #999;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
